import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsxs as e, jsx as i, Fragment as a } from "react/jsx-runtime";
import { Accordion as s } from "@design-system/accordion";
import { Button as t } from "@design-system/button";
import { ExtendableImage as r } from "@design-system/extendable-image";
import { Typography as c } from "@design-system/typography";
import n from "classnames";
import { forwardRef as d, useState as o } from "react";
var m = function m(e) {
    var i = [];
    return Object.keys(e).forEach(function (a) {
      i.push("".concat(a, "=").concat(e[a]));
    }), i.join("&");
  },
  l = d(function (_ref, y) {
    var d = _ref.className,
      l = _ref.link,
      _ref$queryParams = _ref.queryParams,
      p = _ref$queryParams === void 0 ? {
        modestbranding: 1,
        rel: 0,
        enablejsapi: 1
      } : _ref$queryParams,
      v = _ref.preview,
      g = _ref.transcript,
      b = _ref.iframeTitle,
      _ = _ref.noJsLabel;
    var _o = o(!1),
      _o2 = _slicedToArray(_o, 2),
      j = _o2[0],
      f = _o2[1];
    return e("div", Object.assign({
      ref: y,
      className: n("cds-video", d)
    }, {
      children: [e("div", Object.assign({
        className: "cds-video__wrapper"
      }, {
        children: [j || !v ? i("iframe", {
          className: "cds-video__frame",
          "data-testid": "video-iframe",
          loading: "lazy",
          src: "".concat(l, "?").concat(m(p)).concat(v ? "&autoplay=1" : ""),
          title: b,
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowFullScreen: !0
        }) : e(a, {
          children: [i("div", Object.assign({
            className: "cds-video__preview"
          }, {
            children: i(r, Object.assign({
              className: "cds-video__preview-image",
              "data-testid": "preview-image"
            }, v.previewImage))
          })), i("div", Object.assign({
            className: "cds-video__btn_wrapper"
          }, {
            children: i(t, Object.assign({
              className: "cds-video__preview-btn",
              "data-testid": "preview-button",
              variant: "primary-icon",
              size: "large",
              onClick: function onClick() {
                return f(!0);
              }
            }, v.previewBtn))
          }))]
        }), i("noscript", {
          children: _ && i("div", Object.assign({
            className: "cds-video__no-js"
          }, {
            children: i(c, {
              className: "cds-video__no-js-text",
              "data-testid": "no-js-text",
              tag: "p",
              variant: "body",
              size: "s",
              content: _
            })
          }))
        })]
      })), (j || !v) && g && i(s, {
        headlineTag: "h2",
        className: "cds-video__transcript",
        semanticVariant: "div",
        "data-testid": "transcript",
        items: [{
          title: g.transcriptLabel,
          children: i(c, {
            tag: "div",
            variant: "body",
            size: "m",
            content: g.transcriptContent
          })
        }]
      })]
    }));
  });
export { l as Video };